import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import GeneralHtmlSupport from "@ckeditor/ckeditor5-html-support/src/generalhtmlsupport";
// https://ckeditor.com/docs/ckeditor5/latest/features/general-html-support.html
class _Plugin extends Plugin {
}
class ExtendHtmlSupport extends _Plugin {
    static get requires() {
        return [GeneralHtmlSupport];
    }
    init() {
        /*
        // Extend schema with custom HTML elements.
        const dataFilter: any = this.editor.plugins.get('DataFilter');
        const dataSchema = this.editor.plugins.get('DataSchema');

        // Inline element
        dataSchema.registerInlineElement({
            view: 'element-inline',
            model: 'myElementInline'
        });

        // Custom elements need to be registered using direct API instead of config.
        dataFilter.allowElement('element-inline');
        dataFilter.allowAttributes({ name: 'element-inline', attributes: { 'data-foo': false }, classes: ['foo'] });

        // Block element
        dataSchema.registerBlockElement({
            view: 'element-block',
            model: 'myElementBlock',
            modelSchema: {
                inheritAllFrom: '$block'
            }
        });

        dataFilter.allowElement('element-block');
        */
        const dataFilter = this.editor.plugins.get('DataFilter');
        const dataSchema = this.editor.plugins.get('DataSchema');
        dataSchema.registerInlineElement({
            view: 'router-link',
            model: 'routerLink'
        });
        dataFilter.allowElement('router-link');
        dataFilter.allowAttributes({ name: 'router-link', attributes: { 'to': true }, classes: [] });
    }
}
export default ExtendHtmlSupport;
